import classNames from 'classnames';
import fp from 'lodash/fp';
import React from 'react';
import { Nav, Navbar, NavItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { matchPath, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { compose, withProps } from 'recompose';
import { links, routes } from '../../constants';
import AdminNavMobile from './nav/admin-nav-mobile';
import NavMobile from './nav/nav-mobile';
import PublisherNavMobile from './nav/publisher-nav-mobile';

const Footer = ({
  isAuthenticated,
  location,
  logo,
  match,
  routesNoFooter,
  routesNoMobileNav,
  status
}) => (
    !fp.includes(location.pathname)(routesNoFooter) ?
      <div
        className={classNames(
          match ?
            fp.flow(
              fp.get(match.path),
              (value) => fp.getOr(value)('className')(value)
            )(status) :
            null,
          'clearfix'
        )}>
        <footer className='pageFooter'>
          <Navbar bsStyle='footer' fluid={true}>
            <Navbar.Header>
              <Navbar.Brand>
                <Link to={routes.app.dashboard}>
                  <img src={logo} alt='Caddie' />
                </Link>
              </Navbar.Brand>
            </Navbar.Header>
            <Navbar.Collapse>
              <Nav pullRight>
                <NavItem eventKey={1} href={links.thinkCaddie.about} target='_blank'>
                  About
                </NavItem>
                <NavItem eventKey={2} href={links.thinkCaddie.contact} target='_blank'>
                  Contact
                </NavItem>
                <NavItem eventKey={3} href={links.thinkCaddie.terms} target='_blank'>
                  Terms
                </NavItem>
                <NavItem eventKey={4} href={links.thinkCaddie.privacy} target='_blank'>
                  Privacy
                </NavItem>
                <NavItem eventKey={5} href={`mailto:support@thinkcaddie.com?subject=Caddie Support Request&cc=helpdesk@complii.com.au`}>
                  Support
                </NavItem>
                <NavItem eventKey={6} href={links.thinkCaddie.blog} target='_blank'>
                  Blog
                </NavItem>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </footer>
        {
          isAuthenticated ?
            matchPath(location.pathname, { path: routes.publisherPortal.root }) ?
              <PublisherNavMobile /> :
              matchPath(location.pathname, { path: routes.adminPortal.root }) ?
                <AdminNavMobile /> :
                fp.any((path) =>
                  matchPath(location.pathname, { path })
                )(routesNoMobileNav) ?
                  null :
                  <NavMobile /> :
            null
        }
      </div> :
      null
  );

const mapStateToProps = (state) => ({
  isAuthenticated: state ? state.session.isAuthenticated : false
});

export default compose(
  withRouter,
  connect(mapStateToProps),
  withProps({
    status: {
      [routes.login]: 'logged-out',
      [routes.forgotPassword]: 'logged-out',
      [routes.resetPassword]: 'logged-out',
      [routes.onboarding.root]: {
        className: 'sign-up',
        exact: false
      }
    }
  }),
  withProps(({
    location: {
      pathname
    },
    status
  }) => ({
    match: fp.find(
      fp.identity,
      fp.map((key) =>
        matchPath(pathname, {
          path: key,
          exact: fp.getOr(true)(`${key}.exact`)(status)
        })
      )(fp.keys(status))
    ),
    routesNoFooter: [
      routes.app.training.content
    ],
    routesNoMobileNav: fp.keys(status)
  }))
)(Footer);



// WEBPACK FOOTER //
// ./src/containers/partials/footer.js